// Shared constants for the college document mapping page (MappingPage + its helpers).

/** Mirrors backend `DocumentFieldType`. */
export const FIELD_TYPES = [
  "TEXT",
  "MULTILINE",
  "DATE",
  "EMAIL",
  "PHONE",
  "CHECKBOX",
  "SIGNATURE",
  "PHOTO",
];

/** Signer roles this page lets an admin pick directly (mirrors a subset of the backend
 * `DocumentSignerRole` enum: the college workflow only ever hands a field to one of these three
 * manually; the rest are either resolution outcomes or specific to the generic Document Centre). */
export const OWNERS = ["CLIENT", "ADMIN_PRE_SEND", "ADMIN_POST_SIGN"];

/** Set automatically (never picked directly) once a field is linked to a prefill key. */
export const AUTOFILL_OWNER = "AUTOFILLED";

export const DEFAULT_FIELD_TYPE = "TEXT";
export const DEFAULT_FIELD_OWNER = "CLIENT";

// A freshly-added field starts as a small, visible box near the top-left of the page so it's easy
// to find and drag into place, not zero-sized and not off the edge.
export const DEFAULT_FIELD_X_PCT = 0.1;
export const DEFAULT_FIELD_Y_PCT = 0.1;
export const DEFAULT_FIELD_WIDTH_PCT = 0.25;
export const DEFAULT_FIELD_HEIGHT_PCT = 0.04;

export const FIRST_PAGE_NUMBER = 1;

/** Sentinel used for the "not linked" option in the prefill-key select. MUI TextField select
 * values can't be `null`, so the field list keeps `null` and the UI layer swaps at this boundary. */
export const NO_PREFILL_VALUE = "";

/** Max height (px) of the scrollable field list before it scrolls internally. */
export const FIELD_LIST_MAX_HEIGHT = 560;

/** Prefix of the prefill keys filled from a linked admission. Unlike every other source, these are
 * allowed to resolve to nothing: a college form is legitimately sent without an admission linked,
 * and the sender is asked to type those values instead of the send being refused. */
export const ADMISSION_PREFILL_PREFIX = "application.admission.";
